import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { useParams, useNavigate } from "react-router-dom";
import "../../assets/css/authentification/otp.css";
import LoaderAuth from "../../components/loader/authentification/LoaderAuth";
const Otp = ({setAlert}) => {
  const navigate = useNavigate();
  const { verifyOtp, isLoading, setIsLoading } = useContext(AuthContext);
  const { email, userId } = useParams();
  const [code, setCode] = useState("");
  const isValid = Boolean(userId && email);
  useEffect(() => {
    if (!isValid) {
      navigate("/connexion");
    }
  }, [isValid]);
  const handleSubmit = (ev) => {
    ev.preventDefault();
    setIsLoading(true)
    if (code.length !== 6) {
      return alert("Le code doit comporter 6 chiffres.");
    }
    let deviceId = localStorage.getItem("deviceId");
    verifyOtp({ otp: code, email: email, userId: userId, deviceId },setAlert);
  };
  const displayEmail = email
    ? `...${email.substring(email.indexOf("@") - 4)}`
    : "votre addresse email";
  return (
    <>
      {isLoading ? (
        <><LoaderAuth/></>
      ) : (
        <>
          <div className="container otp_container">
            <i
              class="bi bi-x-circle login_icon_x"
              role="button"
              onClick={() => navigate("/")}
            ></i>
            <div className="otp_header">
              <h1>Validation à deux étapes</h1>
              <p>
                Merci d'entre le code à 6 chiffre envoyer à cette addresse:
                {displayEmail}
              </p>
            </div>
            <form className="otp_form" onSubmit={handleSubmit}>
              <input type="text" defaultValue={code} onChange={(ev)=>setCode(ev.target.value)} placeholder="Entre le code à 6 chiffres" required/>
              <button type="submit" >
                <span>VALIDER</span>
              </button>
            </form>
          </div>
        </>
      )}
    </>
  );
};

export default Otp;
